import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import TabsPage from '../views/TabsPage.vue'
import store from '../store'
import { Preferences } from '@capacitor/preferences';
import { logoutKeycloak } from '@/utils/keycloakLogout'

const routes = [
  {
    path: '/',
    redirect: '/tabs/home'
  },
  {
    path: '/tabs/',
    component: TabsPage,
    children: [
      {
        path: '',
        redirect: '/tabs/home'
      },
      {
        path: 'home',
        component: () => import('@/views/HomeTabPage.vue'),
        
      },
      {
        path: 'leads',
        component: () => import('@/views/LeadTabPage.vue'),
        
      },
      {
        path: 'agenda',
        component: () => import('@/views/AgendaTabPage.vue'),
        
      },
      {
        path: 'profile',
        component: () => import('@/views/ProfileTabPage.vue')
      }
    ]
  },
  {
    path: '/logout',
    name:'LogOut',
    component: () => import('@/views/HomeTabPage.vue'),
    beforeEnter() {
      logoutKeycloak(store.state.auth.idToken)
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {

    if(to.query.account_id) {
        store.dispatch("auth/SET_CURRENT_ACCOUNT_ID", to.query.account_id);

        await Preferences.set({
            key: 'account_id',
            value: to.query.account_id,
        });
    }

    next();

});

export default router
